import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pre-btn",
  "use": "icon-pre-btn-usage",
  "viewBox": "0 0 207 605",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 207 605\" id=\"icon-pre-btn\">\n\t<title>pre-btn</title>\n\t<style>\n\t\t#icon-pre-btn tspan { white-space:pre }\n\t\t#icon-pre-btn .shp0 { fill: #000000 } \n\t</style>\n\t<path id=\"icon-pre-btn_pre-btn\" class=\"shp0\" d=\"M206.3 604.5L0.7 302.5L206.3 0.5L206.3 604.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol